import {
  InfoIcon,
  PermissionIcon,
  ShaprLogoIcon,
  SuccessIcon,
  WarningIcon,
} from "../CompositeIcons/CompositeIcons";

import style from "./InfoPage.module.css";

type Variant = "information" | "warning" | "success" | "permission" | "default";

const icons: Record<Variant, React.ReactNode> = {
  success: <SuccessIcon />,
  warning: <WarningIcon />,
  information: <InfoIcon />,
  permission: <PermissionIcon />,
  default: <ShaprLogoIcon />,
};

function StatusIcon({ variant }: { variant?: Variant }) {
  return icons[variant ?? "default"];
}

export const InfoPage: React.FC<{
  title: React.ReactNode;
  variant?: Exclude<Variant, "default">;
  description?: React.ReactNode;
  primaryCTALabel?: React.ReactNode;
  primaryCTA?: React.ReactNode;
  body?: React.ReactNode;
  footer?: React.ReactNode;
}> = ({ title, primaryCTA, primaryCTALabel, description, variant, body, footer }) => {
  return (
    <div className={style.pageCenterContainer}>
      <div className={style.container}>
        <div className={style.infoPageContainer}>
          <StatusIcon variant={variant} />
          <div>
            <h1 className={style.title}>{title}</h1>
            {description && <div className={style.description}>{description}</div>}
          </div>
          {body && <div>{body}</div>}
          {primaryCTA && (
            <>
              <div className={style.separator} />
              <div>
                {primaryCTALabel && <div className={style.ctaLabel}>{primaryCTALabel}</div>}
                <div className={style.ctaContainer}>{primaryCTA}</div>
              </div>
            </>
          )}
        </div>
        {footer && <div>{footer}</div>}
      </div>
    </div>
  );
};
